"use client";

import { type ReactNode, useEffect, useState } from "react";
import { useNavigation } from "@/shared/navigation/useNavigation";
import {
  getLocaleFromCookie,
  type Locale,
} from "@/shared/utils/locale-cookies";
import { env } from "@/env";
import { cn } from "@/components/libs/cn";
type LocaleRedirectProps = {
  children: ReactNode;
  currentLocale: Locale;
};

export function LocaleRedirect({
  children,
  currentLocale,
}: LocaleRedirectProps) {
  const [shouldRender, setShouldRender] = useState(!env.VITE_MULTILINGUAL);
  const { replace } = useNavigation();

  useEffect(() => {
    if (!env.VITE_MULTILINGUAL) {
      return;
    }

    const cookieLocale = getLocaleFromCookie();

    if (cookieLocale !== currentLocale) {
      replace(`/${cookieLocale}`);
    } else {
      setShouldRender(true);
    }
  }, [currentLocale, replace]);

  return (
    <div className={cn("flex flex-1 flex-col", !shouldRender && "hidden")}>
      {children}
    </div>
  );
}
